'use strict'

export const SESSION_KEY_USER = 'SESSION_KEY_USER' // 存储用户信息
export const LOCAL_KEY_CURRENT_LANGUAGE = 'jy-session-key-curr-lang' // 当前系统语言: 存储时存的是LanguageEnum.text, 挂载在windows上时是枚举LanguageEnum
export const LOCAL_KEY_FIELD_OVERVIEW_MAP_FARM_CENTER = 'jy-session-key-filed-overview-map-center' // field-overview页面最近一次的基地地图中心点。存储信息是{lng: 123.123456, lat: 35.123456}
export const LOCAL_KEY_FILTER_PREFERENCE = 'jy-user-pref-filter-' // 用户筛选项偏好，该key为前缀，页面router为后缀，页面内自行区分各筛选项



// WEBPACK FOOTER //
// ./src/constants/StorageKeys.js